module.exports = __webpack_public_path__ + "img/deposit.f9a776c0.svg";